import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x6701,
  properties: ["read", "write", "notify"],
};

export function generateMockICCNofifyData(): DomianControl.ICCNotifyData {
  const data = getMockDataByKeys(
    [
      "UIRx_ACUYawRate",
      "UIRx_DeltaOff_FA",
      "UIRx_DeltaOff_RA",
      "UIRx_SBW_HWAAng",
      "UIRx_WhlBrkTqAct_FL_BCh1",
      "UIRx_WhlBrkTqAct_FR_BCh1",
      "UIRx_WhlBrkTqAct_RL_BCh1",
      "UIRx_WhlBrkTqAct_RR_BCh1",
      "UIRx_FrontGearRto",
      "UIRx_RearGearRto",
      "UIRx_AxleStAng_FA",
      "UIRx_AxleStAng_RA",
      "UIRx_PinionTarVgr",
      "UIRx_PinionAct",
    ],
    // {
    //   UIRx_ACULatAcc: [-1, 1],
    //   UIRx_ACULongdAcc: [-1, 1],
    //   UIRx_ACUYawRate: [-75, 75],
    //   UIRx_DeltaOff_FA: [-5, 5],
    //   UIRx_SBW_HWAAng: [-500, 500],
    //   UIRx_DeltaOff_RA: [-5, 5],
    //   UIRx_alphaRA: [-5, 5],
    //   UIRx_WhlBrkTqAct_FL_BCh1: [0, 2000],
    //   UIRx_WhlBrkTqAct_FR_BCh1: [0, 2000],
    //   UIRx_WhlBrkTqAct_RL_BCh1: [0, 2000],
    //   UIRx_WhlBrkTqAct_RR_BCh1: [0, 2000],
    // }
  );
  return data;
}

// generateMockICCNofifyData();
